export default __webpack_public_path__ + "61ae7da801baee74a802797b13710c3c.png";